<template>
	<Badge @click="onclick" class="h-12" icon="bxs:info-circle" color="bg-yellow-500" text-color="text-yellow-500">
		<img :src="assetsUrl + '/img/bolsa_segura.webp'" class="w-full px-1 py-2" alt="Imagem de um texto: Bolsa Segura" />
	</Badge>
	<Modal ref="pos_paid_modal">
		<h1 class="text-2xl">Bolsa Segura</h1>
		<p>
			O Bolsa Segura é uma modalidade em que você agarra a bolsa de estudos do seu interesse, aqui no Vai de Bolsa,
			através de uma pré-matrícula. Depois dá início no processo de matrícula diretamente com a faculdade e,
			assim que a sua matrícula estiver pronta, você realiza o pagamento da sua bolsa.
		</p>
	</Modal>
</template>

<script lang="ts" setup>
	import Badge from "~/components/app/badge.vue";
	import Modal from "~/components/common/modal.vue";

	const { assetsUrl } = useRuntimeConfig();

	const pos_paid_modal = ref();

	const onclick = () => {
		pos_paid_modal.value.open();
	};
</script>

<style scoped>

</style>
